import { supabase } from '../../lib/supabase'

export const evidenceProvider = {
  async history(input: {
    tenantId: string
    objectType?: string
    objectId?: string
    actorId?: string
    eventKind?: string
    eventVersion?: number
    limit?: number
  }) {
    return supabase.rpc('get_evidence_history', {
      p_tenant_id: input.tenantId,
      p_object_type: input.objectType ?? null,
      p_object_id: input.objectId ?? null,
      p_actor_id: input.actorId ?? null,
      p_event_kind: input.eventKind ?? null,
      p_event_version: input.eventVersion ?? null,
      p_limit: input.limit ?? 100,
    })
  },

  async metrics(tenantId: string, since?: string) {
    return supabase.rpc('get_evidence_metrics', {
      p_tenant_id: tenantId,
      p_since: since ?? new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    })
  },
}
